import type { WorkbenchPanel, WorkbenchPanelToggle } from '@kerfjs/ui/workbench';

import { SidebarList } from './sidebar-list.js';
import { ViewSegmentedControl } from './view-segmented-control.js';

/** The navigation rail's standard Workbench toggle (HS2-AC9K4G). */
export const SIDEBAR_TOGGLE: WorkbenchPanelToggle = {
  action: 'toggle-sidebar',
  name: 'Sidebar',
  hideLabel: 'Collapse Sidebar',
};

/**
 * Production navigation rail as a Workbench panel: its toolbar carries the
 * primary-view switcher and the standard toggle, and the contextual list fills
 * the rail's `nav` pane. Kerf relocates the switcher and the toggle into the
 * work area's toolbar while the rail is collapsed (HS2-AC9K4G). Every role has at
 * least Demands and Settings, so every rail carries the switcher (HS2-CJM2YK).
 */
export function sidebarPanel({ view: v, collapsed }: { view: string; collapsed: boolean }): WorkbenchPanel {
  return {
    label: 'Navigation',
    collapsed,
    toolbar: {
      label: 'Navigation',
      leading: <ViewSegmentedControl view={v} />,
      toggle: SIDEBAR_TOGGLE,
    },
    pane: { contentElement: 'nav', contentLabel: 'Navigation' },
    content: <SidebarList view={v} />,
  };
}
